// extracted by mini-css-extract-plugin
export default {"title":"AskItem_title__FaV0V","p":"AskItem_p__RxQe8","accordionListContent":"AskItem_accordionListContent__1hAih"};